import type { ColumnFilterState } from '../useFilterState'
import { CheckFilter } from './checkFilter/CheckFilter'
import { DateRangeFilter } from './DateRangeFilter'
import { NumberRangeFilter } from './NumberRangeFilter'
import { RadioFilter } from './RadioFilter'

type Props<T> = {
  state: ColumnFilterState<T>
  onStateChanged: (state: ColumnFilterState<T>) => void
}

export const ColumnFilter = <T,>({ state, onStateChanged }: Props<T>) => {
  switch (state.type) {
    case 'auto':
      return <CheckFilter state={state} onStateChanged={onStateChanged} />
    case 'numberRange':
      return <NumberRangeFilter state={state} onStateChanged={onStateChanged} />
    case 'dateRange':
      return <DateRangeFilter state={state} onStateChanged={onStateChanged} />
    case 'radio':
      return <RadioFilter state={state} onStateChanged={onStateChanged} />
    default:
      return null
  }
}
